import React, { useState, useEffect } from 'react'

import PropTypes from 'prop-types'
import { Row, Col, Checkbox, Button, Modal, Input, notification } from 'antd'
import moment from 'moment-timezone'
import { isEmpty } from 'lodash';
import { saveAs } from 'file-saver'
import { translate } from 'react-i18next'

import { IconHelper, byteToMbGb, apiHelper, getHttpClient, genVRoomToken } from '../../helpers'

const parseText = function (text, limit) {
  if (text.length > limit) {
    for (let i = limit; i > 0; i--) {
      if (text.charAt(i) === ' ' && (text.charAt(i - 1) !== ',' || text.charAt(i - 1) !== '.' || text.charAt(i - 1) !== ';')) {
        return text.substring(0, i) + '...';
      }
    }
    return text.substring(0, limit) + '...';
  }
  else
    return text;
};

const parseRecordFile = function (text, limit) {
  if (text.length > limit) {
    for (let i = limit; i > 0; i--) {
      if (text.charAt(i) === ' ' && (text.charAt(i - 1) !== ',' || text.charAt(i - 1) !== '.' || text.charAt(i - 1) !== ';')) {
        return text.substring(0, i) + '....mp4';
      }
    }
    return text.substring(0, limit) + '....mp4';
  }
  else
    return text;
};

const RecordItem = ({ t, keycloak, conferenceId, recordId, roomName, fileName, isChecked, onChecked, hideAction, deleteAction, recordFileSize, startRecordTime, stopRecordTime, language }) => {
  const { IconDownloadRed, IconCopyRed, IconDeleteRed } = IconHelper
  const [timeDetail, setTimeDetail] = useState('')
  const [isStartStopSameDate, setIsStartStopSameDate] = useState(false);
  const [isCopyModalVisible, setIsCopyModalVisible] = useState(false);
  const [recordDownloadUrl, setRecordDownloadUrl] = useState('')
  const [showPopupConfirm, setShowPopupConfirm] = useState(false)

  const getPreSignedURL = async () => {
    const url = window._env_.recordHistory + apiHelper.generatePreSignedURL(recordId)
    try {
      const token = await genVRoomToken(keycloak)
      const generatePreSigned = await getHttpClient(keycloak, url, { Authorization: "Bearer " + token })
      return generatePreSigned
    } catch (error) {
      console.error('getPreSignedURL', error)
    }
  }

  const handleChange = (value) => {
    onChecked(recordId, value.target.checked)
  }

  const handleDownloadAction = async (fileName) => {
    console.log('download')
    try {
      const result = await getPreSignedURL();
      const name = fileName.replace('.mp4', '')

      if (!isEmpty(result.data?.SignedUrl)) {
        const url = result.data?.SignedUrl
        const link = url.split('records')
        const linkDownload = `${window._env_.vRoomUrl}/download/records${link[1]}`
        if (saveAs(linkDownload, name)) {
          notification.success({
            message: "download video",
            placement: "bottomRight",
            style: { width: '300px' }
          })
        }
      } else {
        console.log('download fail')
        if (result.status?.code === 404) {
          setShowPopupConfirm(true)
        }
      }
    } catch (err) {
      console.error('onSaveFilePrivate:', err)
    }
  }

  // const copyToClipboard = (textToCopy) => {
  //   // navigator clipboard api needs a secure context (https)
  //   if (navigator.clipboard && window.isSecureContext) {
  //       // navigator clipboard api method'
  //       return navigator.clipboard.writeText(textToCopy);
  //   } else {
  //       // text area method
  //       let textArea = document.createElement("textarea");
  //       textArea.value = textToCopy;
  //       // make the textarea out of viewport
  //       textArea.style.position = "fixed";
  //       textArea.style.left = "-999999px";
  //       textArea.style.top = "-999999px";
  //       document.body.appendChild(textArea);
  //       textArea.focus();
  //       textArea.select();
  //       return new Promise((resolve, reject) => {
  //           let result = document.execCommand('copy');
  //           console.log('copy result', result)
  //           textArea.remove();

  //           if (!result) {
  //             console.log('show prompt');
  //             const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
  //             const copyHotkey = isMac ? '⌘C' : 'CTRL+C';
  //             result = prompt(`Press ${copyHotkey}`, textToCopy);
  //           }

  //           result ? resolve() : reject();
  //       });
  //   }
  // }

  const handleCopyAction = async () => {
    console.log('copy')
    try {
      const result = await getPreSignedURL();
      if (result.data?.SignedUrl) {
        try {
          await navigator.clipboard.writeText(result.data.SignedUrl)
          // await copyToClipboard(result.data.SignedUrl)
          console.log('try copy success')
          notification.success({
            message: `${t('my_record.copy_link')}`,
            placement: "bottomRight",
            style: { width: '300px' }
          });
        } catch (error) {
          console.log('try copy fail')
          setRecordDownloadUrl(result.data?.SignedUrl)
          setIsCopyModalVisible(true)
          // let copyText = 'Press CTRL+C to copy'
          // if(navigator.platform.toUpperCase().indexOf('MAC') >= 0) {
          //   copyText = 'Press ⌘C to copy'
          // }
          // if(navigator.platform.toUpperCase().indexOf('IP') >= 0) {
          //   copyText = 'Please select all and copy'
          // }

          // prompt(copyText, result.data.SignedUrl);
        }
      } else {
        console.log('copy fail')
        if (result.status?.code === 404) {
          setShowPopupConfirm(true)
        }
      }
    } catch (err) {
      console.error('onCopyPrivate:', err)
    }
  }

  const renderRoomname = (name) => {
    return (
      <span>
        <span className="class-name-to-show-mobile-hide-desktop">{parseText(name, 22)}</span>
        <span className="class-name-to-show-desktop-hide-mobile">{parseText(name, 35)}</span>
      </span>
    )
  }

  const renderFilename = (name) => {
    return (
      <span>
        <span className="class-name-to-show-mobile-hide-desktop">{parseRecordFile(name, 15)}</span>
        <span className="class-name-to-show-desktop-hide-mobile">{name}</span>
      </span>
    )
  }

  const handleDeleteAction = () => {
    console.log('delete')
    deleteAction(recordId)
  }

  const dateLanguage = (date, language) => {
    if (language === 'th') {
      return moment(date).add(543, 'year').tz('Asia/Bangkok').locale(language).format('ll')
    } else if (language === 'cn') {
      return moment(date).tz('Asia/Bangkok').locale(language).format('ll')
    } else {
      return moment(date).tz('Asia/Bangkok').locale(language).format('MMM Do YYYY')
    }
  }

  const timeLanguage = (time) => {
    return moment(time).tz('Asia/Bangkok').locale('en').format('h:mm a').toUpperCase()
  }

  const handleFocus = (event) => event.target.select();

  useEffect(() => {
    // const startDate = moment(startRecordTime).tz('Asia/Bangkok').locale(language).format('MMM Do YYYY')
    const startDate = dateLanguage(startRecordTime, language)
    const startTime = timeLanguage(startRecordTime)

    const stopDate = dateLanguage(stopRecordTime, language)
    const stopTime = timeLanguage(stopRecordTime)

    const isSameDate = startDate === stopDate;

    let timeString = '';
    if (isSameDate) {
      setIsStartStopSameDate(true)
      timeString = `${startDate}, ${startTime} - ${stopTime}`
    } else {
      timeString = `${startDate}, ${startTime} - ${stopDate}, ${stopTime}`
    }
    setTimeDetail(timeString)

    return () => { }
  }, [startRecordTime, stopRecordTime, language])

  return (
    <div>
      <Col span={24} id="record">
        <Row type="flex">
          <Col xs={24} sm={24} className="record-item-label">
            <Checkbox checked={isChecked} onChange={handleChange} className="vroom-checkbox">
              <strong>{t('my_record.roomname')}</strong> {renderRoomname(decodeURI(roomName))}<br />
              <strong>{t('my_record.roomfile')}</strong> {renderFilename(fileName)}<br />
              <strong>{t('my_record.date')}</strong> {timeDetail} {!isStartStopSameDate ? <br /> : <span className="mobile-100" />} <strong>{t('my_record.size')}</strong> {byteToMbGb(recordFileSize)}
            </Checkbox>
          </Col>
          <Col xs={24} sm={24} className="record-action">
            {!hideAction ? <div className="action-bar">
              <Button type="link" className="record-action-button" icon={<IconDownloadRed />} onClick={() => handleDownloadAction(fileName)}>
                {t('my_record.action_download')}
              </Button>
              <Button type="link" className="record-action-button" icon={<IconCopyRed />} onClick={handleCopyAction}>
                {t('my_record.action_copy')}
              </Button>
              <Button type="link" className="record-action-button" icon={<IconDeleteRed />} onClick={handleDeleteAction}>
                {t('my_record.action_delete')}
              </Button>
            </div> : null}
          </Col>
          {/* <Col xs={24} sm={4} className="record-item-action">
            {!hideAction ? <div className="action-bar">
              <div className="class-name-to-show-desktop-hide-mobile">
                <Tooltip placement="top" title="Download">
                  <span className="action"><IconDownload  onClick={handleDownloadAction} /></span>
                </Tooltip>
                <Tooltip placement="top" title="Copy">
                  <span className="action"><IconCopy onClick={handleCopyAction}/></span>
                </Tooltip>

                <Tooltip placement="top" title="Delete">
                  <span className="action"><IconDelete onClick={handleDeleteAction} /></span>
                </Tooltip>
              </div>
              <div className="class-name-to-show-mobile-hide-desktop space-btween">
                <span className="action"><IconDownload  onClick={handleDownloadAction} /></span>
                <span className="action"><IconCopy onClick={handleCopyAction}/></span>
                <span className="action"><IconDelete onClick={handleDeleteAction} /></span>
              </div>
                
            </div> : null}
          </Col> */}
        </Row>
      </Col>
      <Modal
        title={t('my_record.select_and_copy')}
        closable={false}
        centered={true}
        visible={isCopyModalVisible} footer={[
          <Button key="close" onClick={() => setIsCopyModalVisible(false)}>
            {t('my_record.delete_error_close')}
          </Button>,
        ]}>
        <Input.TextArea rows={5} value={recordDownloadUrl} onFocus={handleFocus} />
      </Modal>
      <Modal
        title={null}
        centered
        visible={showPopupConfirm}
        onOk={() => console.log("ok")}
        onCancel={() => setShowPopupConfirm(false)}
        closable={false}
        footer={false}
        width={400}
        className="record-delete-popup"
      >
        <Row type="flex" justify="center">
          <Col md={24} sm={24} xs={24} className="content">
            {
              <div className="delete-popup-error">
                <div className="delete-logo">
                  <img alt="delete" src="/portal/img/delete-red.png" />
                </div>
                <div className="popup-title">{t('my_record.delete_error_title')}</div>
                <div className="popup-detail">{t('my_record.delete_error_detail')}</div>
                <div className="action-pad">
                  <Button className="popup-delete-btn" onClick={() => setShowPopupConfirm(false)}>{t('my_record.delete_error_close')}</Button>
                </div>
              </div>
            }
          </Col>
        </Row>
      </Modal>
    </div>
  )
}

RecordItem.propTypes = {
  fileName: PropTypes.string,
  isChecked: PropTypes.bool,
  roomName: PropTypes.string,
  startRecordTime: PropTypes.string,
  stopRecordTime: PropTypes.string,
  hideAction: PropTypes.bool,
  deleteAction: PropTypes.func,
  recordFileSize: PropTypes.string
}

export default translate()(RecordItem)
